export default "__VITE_ASSET__DwPxYmB7__"